<div class="agpr-quota-dropdown">
    <button
        class="agpr-quota-dropdown-header"
        [attr.aria-expanded]="!collapsed"
        (click)="toggleRecipientSummary($event)"
    >
        <label>
            {{ 'Discover.distribution.totalRecipients' | localize }}
        </label>
        <span class="agpr-float-right">
            {{ totalRecipients | number }}
            <span
                role="img"
                class="agpr-quota-dropdown-toggler fa-solid"
                [ngClass]="{
                    'fa-angle-down': collapsed,
                    'fa-angle-up': !collapsed
                }"
            ></span>
        </span>
    </button>
    @if (totalRecipients > 10000) {
        <agpr-message
            [severity]="messageSeverity.warning"
            class="agpr-quota-dropdown-tooManyRecipients"
        >
            <p>{{ 'Discover.targeting.distribution.editRecipient.summary.tooManyRecipients' | localize }}</p>
            <p>
                <a
                    href="http://help.agilitypr.com/en/collections/753051-discover"
                    target="_blank"
                    class="agpr-contact-link"
                >
                    Click here</a>{{ 'Discover.targeting.distribution.editRecipient.summary.listBuldingTips' | localize }}
            </p>
        </agpr-message>
    }

    @if (showThirdPartyWarning && totalRecipients > 50) {
        <agpr-message
            [severity]="messageSeverity.warning"
            class="agpr-quota-dropdown-nylas-tooManyRecipients"
        >
            <p>{{ 'Discover.targeting.distribution.header.sendFrom.warning' | localize }}</p>
            <ul class="agpr-quota-dropdown-nylas-tooManyRecipients-list">
                <li>{{'Discover.targeting.distribution.header.sendFrom.warning.text1' | localize}}</li>
                <li>{{'Discover.targeting.distribution.header.sendFrom.warning.text2' | localize}}</li>
                <li>{{'Discover.targeting.distribution.header.sendFrom.warning.text3' | localize}}</li>
                <li>{{'Discover.targeting.distribution.header.sendFrom.warning.text4' | localize}}</li>
            </ul>
        </agpr-message>
    }

    <agpr-quota-message
        [totalUsagePercentage]="remainingUsagePercentage"
        [threshold]="50"
        [remainingCount]="remainingUsageCount"
        [remainingThreshold]="1000"
        [infoMessage]="!!quotaResetDate
            ? ('Discover.targeting.distirbution.editRecipient.quotaInfoMessage' | localize: {
                count: recipientsAvailable,
                date: quotaResetDate
            })
            : ('Discover.targeting.distirbution.editRecipient.quotaInfoMessage.noDate' | localize: {
                count: recipientsAvailable
            })
        "
        [warningMessage]="!!quotaResetDate
            ? ('Discover.targeting.distirbution.editRecipient.quotaWarningMessage' | localize: {
                count: recipientsAvailable,
                date: quotaResetDate
            })
            : ('Discover.targeting.distirbution.editRecipient.quotaWarningMessage.noDate' | localize: {
                count: recipientsAvailable
            })
        "
        [errorMessage]="!!quotaResetDate
            ? ('Discover.targeting.distirbution.editRecipient.quotaErrorMessage' | localize: {
                count: recipientsAvailable,
                date: quotaResetDate
            })
            : ('Discover.targeting.distirbution.editRecipient.quotaErrorMessage.noDate' | localize: {
                count: recipientsAvailable
            })
        "
    >
        <p class="infoLink"><ng-container *ngTemplateOutlet="link"></ng-container></p>
        <p class="warningLink"><ng-container *ngTemplateOutlet="link"></ng-container></p>
        <p class="errorLink"><ng-container *ngTemplateOutlet="link"></ng-container></p>
        <ng-template #link>
            <agpr-button
                [style]="buttonTypes.link"
                label="Discover.targeting.distribution.editRecipient.getMore"
                (click)="openBuyQuotaDialog()"
                [ngClass]="remainingUsagePercentage <= 50 && remainingUsageCount > 1000
                    ? 'agpr-quota-dropdown-contactLink--info': remainingUsagePercentage >= 100
                    ? 'agpr-quota-dropdown-contactLink--error' : 'agpr-quota-dropdown-contactLink--warning'"
            ></agpr-button>
        </ng-template>
    </agpr-quota-message>

    <div
        *ngIf="!collapsed"
        @summaryToggle
        (@summaryToggle.done)="onToggleDone($event)"
        [ngClass]="{'agpr-quota-dropdown--collapsed': collapsed}"
    >
        <div class="agpr-quota-dropdown-stats">
            <div class="agpr-quota-dropdown-stats-row">
                <span>{{ 'Discover.distribution.annualRecipients' | localize }}</span>
                <span class="agpr-float-right">{{ distributionQuotaInfo.totalDistributions | number }}</span>
            </div>
            <div class="agpr-quota-dropdown-stats-row">
                <span>{{ 'Discover.distribution.totalRecipientsUsed' | localize }}</span>
                <span class="agpr-float-right">{{ distributionQuotaInfo.usedDistributions | number }}</span>
            </div>
            <div class="agpr-quota-dropdown-stats-row">
                <span>{{ 'Discover.distribution.remainingRecipients' | localize }}</span>
                <span class="agpr-float-right">{{ distributionQuotaInfo.totalDistributionsAvailable | number }}</span>
            </div>
        </div>
        <!-- TODO: new reqs pending for the visualization
        <div class="agpr-quota-dropdown-chart">
            <agpr-chart [chart]="quotaNoticeChart"></agpr-chart>
        </div> -->
    </div>
</div>
